import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-400 py-12 text-center text-sm px-4">
      <div className="max-w-4xl mx-auto space-y-6">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 mb-4">
          <Link to="/" className="hover:text-white transition-colors">Home</Link>
          <Link to="/contact" className="hover:text-white transition-colors">Contact Us</Link>
          <Link to="/terms" className="hover:text-white transition-colors">Terms & Conditions</Link>
        </div>
        <p>&copy; {new Date().getFullYear()} 7-Day Bill Panic Reset. All rights reserved.</p>
        <p className="text-xs text-slate-500 max-w-2xl mx-auto leading-relaxed">
          Disclaimer: The information provided in this course is for educational purposes only and does not constitute financial advice. Results vary based on individual circumstances.
        </p>
      </div>
    </footer>
  );
}